/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_NoInputs */

const en_cmp_no = /** @type {(inputs: Cmp_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const id_cmp_no = /** @type {(inputs: Cmp_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Cmp_NoInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_no = /** @type {((inputs?: Cmp_NoInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_NoInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_no(inputs)
	return en_cmp_no(inputs)
});